import { Cancel, CheckCircle } from "@mui/icons-material";
import { Typography } from "@mui/material";

export const validServiceColumns = [
    {
        Header: 'Name',
        accessor: 'name',
        enableFilter: true,
    },
    {
        Header: 'Is Taxable',
        accessor: 'isTaxable',
        Cell: ({ value }) => (
            <Typography variant="body2" color={value ? 'green' : 'red'}>
                {value ? <CheckCircle /> : <Cancel />}
            </Typography>
        ),
    },
    {
        Header: 'Tax %',
        accessor: 'defaultTaxPercentage',
        Cell: ({ value }) => (
            <Typography variant="body2">
                {value}%
            </Typography>
        ),
    },
    {
        Header: 'Cost',
        accessor: 'cost',
        disableSortBy: true,
        enableFilter: true,
        type: 'number'
    },
]